import { redirect, render } from 'vike/abort';
import type { PageContext } from 'vike/types';
import { TAX_ICEBERG_PATHS, asTaxIcebergLocale, buildTaxIcebergSlug, parseTaxIcebergSlug, taxIcebergBasePath } from '../../utils/salary/tax-iceberg-url';

/**
 * Canonical-URL enforcement for the page:
 *  - a salary slug that does not parse is a 404, not a silently-defaulted page;
 *  - the legacy `/fi/tax-iceberg` and `/sv/tax-iceberg` forms, and a salary slug written in
 *    another locale's words, 301 to this locale's translated path (query string kept).
 */
export function guard(pageContext: PageContext) {
  const { segment, slug } = (pageContext.routeParams ?? {}) as { segment?: string; slug?: string };
  const locale = asTaxIcebergLocale((pageContext as { locale?: string }).locale);
  const parsed = slug !== undefined ? parseTaxIcebergSlug(slug) : null;
  if (slug !== undefined && !parsed) throw render(404, 'Not a valid salary');

  const canonicalSlug = parsed ? buildTaxIcebergSlug(parsed.gross, parsed.period, locale, parsed.mode) : undefined;
  if (segment !== TAX_ICEBERG_PATHS[locale] || (slug !== undefined && slug !== canonicalSlug)) {
    const search = String(pageContext.urlOriginal ?? '').split('?')[1];
    const target = `${taxIcebergBasePath(locale)}${canonicalSlug ? `/${canonicalSlug}` : ''}${search ? `?${search}` : ''}`;
    throw redirect(target, 301);
  }
}
